// TutorCards.jsx — Responsive Embla swiper
import React, { useState, useEffect, useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';

const tutorsData = [
  {
    id: 1,
    name: "Dr Eno John",
    field: "Mathematics & Computing",
    lastRole: `Director: exams, records and results`,
    firstRole: `Akwa Ibom State Polytechnic`,
    email: "eno.john@gmail.com",
    bio: "Dr. Eno John is a seasoned academic with over 20 years of experience in mathematics education and computing. He has led curriculum development initiatives and mentored numerous students in advanced computational techniques.",
    avatar: "https://thumbs.dreamstime.com/b/portrait-male-african-american-professional-possibly-business-executive-corporate-ceo-finance-attorney-lawyer-sales-stylish-155546880.jpg",
    certificate: ["B.Sc in Computer Science", "PhD in Data Analysis"],
    expertise: ["Html5", "Programming", "Data Structures", "EdTech"],
    courses: 12, students: "4.2k",
    bodies: ["Nigerian Mathematical Society", "Computer Professionals of Nigeria"],
  },

  {
    id: 2,
    name: "Prof. Aisha Mohammed",
    field: "Physics & Electronics",
    firstRole: "Head of Department, University of Lagos",
    lastRole: "Head of Department, University of Lagos",
    email: "aisha.mohammed@unilag.edu.ng",
    bio: "Professor Aisha Mohammed specializes in quantum electronics and renewable energy systems. She has published extensively in international journals and supervised PhD candidates in semiconductor physics.",
    avatar: "https://i0.wp.com/media.premiumtimesng.com/wp-content/files/2022/03/Capture-20.png?fit=667%2C494&ssl=1",
    certificate: ["B.Sc. Mathematics", "M.Sc. Computer Science", "PhD in Computational Mathematics"],
    expertise: ["Quantum Mechanics", "Electronics", "Renewable Energy", "Semiconductors"],
    courses: 9, students: "3.8k",
    bodies: ["Nigerian Mathematical Society", "Computer Professionals of Nigeria"],
  },
  {
    id: 3,
    name: "Dr. Chukwuma Okeke",
    field: "Chemistry & Biochemistry",
    lastRole: "Senior Lecturer, Nnamdi Azikiwe University",
    firstRole: "Nnamdi Azikiwe University",
    email: "chukwuma.okeke@unizik.edu.ng",
    bio: "Dr. Okeke is an expert in organic chemistry and biochemical processes. He has worked on drug discovery projects and environmental chemistry applications relevant to Nigerian industries.",
    avatar: "https://thumbs.dreamstime.com/b/african-american-man-business-guy-male-businessman-looking-window-smiling-camera-portrait-office-employer-manager-company-437392754.jpg",
    certificate: ["B.Sc. Mathematics", "M.Sc. Computer Science", "PhD in Computational Mathematics"],
    expertise: ["Organic Synthesis", "Biochemistry", "Env. Chemistry", "Drug Design"],
    courses: 7, students: "2.9k",
    bodies: ["Nigerian Mathematical Society", "Computer Professionals of Nigeria"],
  },
  {
    id: 4,
    name: "Engr. Fatima Yusuf",
    field: "Electrical Engineering",
    lastRole: "Principal Engineer, NERC",
    firstRole: "NERC",
    email: "fatima.yusuf@nerc.gov.ng",
    bio: "Engineer Fatima Yusuf brings deep industry experience in power systems and electrical infrastructure. She combines practical engineering with academic teaching in power electronics and smart grids.",
    avatar: "https://thumbs.dreamstime.com/b/portrait-call-center-black-man-office-glasses-success-tech-support-african-person-consultant-professional-445451327.jpg",
    certificate: ["B.Sc in Computer Science", "PhD in Mathematics"],
    expertise: ["Power Systems", "Control Eng.", "Smart Grids", "Renewables"],
    courses: 11, students: "5.1k",
    bodies: ["Nigerian Mathematical Society", "Computer Professionals of Nigeria"],
  },

  {
    id: 5,
    name: "Dr Eno John",
    field: "Mathematics & Computing",
    lastRole: `Director: exams, records and results`,
    firstRole: `Akwa Ibom State Polytechnic`,
    email: "eno.john@gmail.com",
    bio: "Dr. Eno John is a seasoned academic with over 20 years of experience in mathematics education and computing. He has led curriculum development initiatives and mentored numerous students in advanced computational techniques.",
    avatar: "https://thumbs.dreamstime.com/b/portrait-male-african-american-professional-possibly-business-executive-corporate-ceo-finance-attorney-lawyer-sales-stylish-155546880.jpg",
    certificate: ["B.Sc in Computer Science", "PhD in Data Analysis"],
    expertise: ["Html5", "Programming", "Data Structures", "EdTech"],
    courses: 12, students: "4.2k",
    bodies: ["Nigerian Mathematical Society", "Computer Professionals of Nigeria"],
  },
];

// ─── Dot Button ───────────────────────────────────────────────────────────────
const DotButton = ({ onClick, isSelected }) => (
  <button
    onClick={onClick}
    aria-label="Go to slide"
    style={{
      width: isSelected ? 24 : 8,
      height: 8,
      borderRadius: 4,
      background: isSelected ? '#9a3412' : '#d1d5db',
      border: 'none',
      cursor: 'pointer',
      padding: 0,
      transition: 'all 0.3s cubic-bezier(0.4,0,0.2,1)',
    }}
  />
);

const TutorCard = ({ tutor, onClick }) => (
  <div
    onClick={() => onClick(tutor)}
    className="group cursor-pointer   flex h-full w-full flex-col overflow-hidden rounded-2xl  border-gray-200 bg-white
     shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
  >
    {/* Header */}
    <div className="flex flex-col items-center border-b border-gray-100 bg-orange-800 px-3 py-2">
      <div className="h-20 w-20 overflow-hidden rounded-full ring-2 ring-white/80 shadow-sm transition-transform duration-300 group-hover:scale-105">
        <img src={tutor.avatar} alt={tutor.name} className="w-full h-full object-cover object-top" />
      </div>
      <h3
        className="mt-3 text-center text-[17px] leading-tight text-white"

      >
        {tutor.name}
      </h3>
      <span
        className="mt-1 px-2.5 py-0.5 text-center text-[10px] uppercase tracking-widest text-orange-50"

      >
        {tutor.field}
      </span>
    </div>

    {/* Body */}
    <div className="flex flex-1 flex-col gap-3 px-4 pb-4 pt-3">



      {/* Stats */}
      <div className="flex justify-center gap-2">
        {[{ label: 'Courses', value: tutor.courses }, { label: 'Students', value: tutor.students }].map(s => (
          <div key={s.label} className="flex-1 rounded-lg border border-gray-100 bg-gray-50 py-2 text-center">
            <p className="font-semibold text-sm text-gray-800" >{s.value}</p>
            <p className="text-gray-400 text-[10px]" >{s.label}</p>
          </div>
        ))}
      </div>
      <span className="line-clamp-2 text-center text-[11px] leading-snug text-gray-500" >
        {tutor.lastRole}
      </span>

      <p className="-mt-2 line-clamp-2 text-center text-[11px] leading-snug text-gray-400" >
        {tutor.firstRole}
      </p>

      <button
        className="mt-auto w-full rounded-xl bg-gray-900 py-2.5 text-xs font-semibold text-white transition-all duration-200 hover:bg-gray-700 active:scale-95"
        style={{ letterSpacing: '0.04em' }}
      >
        View Profile
      </button>
    </div>
  </div>
);

const TutorModal = ({ tutor, onClose }) => {
  if (!tutor) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/40 p-3 backdrop-blur-sm sm:items-center sm:p-4"
      onClick={onClose}
    >
      <div
        className="w-full overflow-y-auto rounded-2xl border border-gray-200 bg-white shadow-xl"
        style={{ maxWidth: 520, maxHeight: '87vh', scrollbarWidth: 'none' }}
        onClick={e => e.stopPropagation()}
      >
        {/* Hero */}
        <div className="flex flex-col items-center border-b border-gray-100 bg-gray-50 px-5 pb-4 pt-5">
          <div className="h-20 w-20 overflow-hidden rounded-full ring-2 ring-gray-200 shadow-md">
            <img src={tutor.avatar} alt={tutor.name} className="w-full h-full object-cover object-top" />
          </div>
          <h2 className="mt-3 text-center text-2xl font-bold leading-tight text-gray-900" >
            {tutor.name}
          </h2>
          <span
            className="text-[10px] font-semibold uppercase tracking-widest text-gray-400 px-2.5 "

          >
            {tutor.field}
          </span>
          <div className="mt-3 flex gap-8">
            {[{ label: 'Courses', value: tutor.courses }, { label: 'Students', value: tutor.students }].map(s => (
              <div key={s.label} className="text-center">
                <p className="text-lg font-bold text-gray-900" >{s.value}</p>
                <p className="text-gray-400 text-[10px] uppercase tracking-wider" >{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Content */}
        <div className="flex flex-col gap-4 px-4 py-4 sm:px-6">
          <div className="grid grid-cols-1 gap-3 rounded-xl border border-gray-100 bg-gray-50 p-3 sm:grid-cols-2">
            <div>
              <p className="text-[10px] text-gray-400 uppercase tracking-widest font-semibold mb-0.5" >Last Role</p>
              <p className="text-gray-700 text-xs leading-snug" >{tutor.lastRole}</p>
            </div>
            <div>
              <p className="text-[10px] text-gray-400 uppercase tracking-widest font-semibold mb-0.5" >Email</p>
              <p className="text-xs text-gray-700 break-all" >{tutor.email}</p>
            </div>
          </div>

          <div>
            <p className="text-[10px] text-gray-400 uppercase tracking-widest font-semibold mb-2" >Courses</p>
            <div className="flex flex-wrap gap-1.5">
              {tutor.expertise.map((s, i) => (
                <span key={i} className="text-xs font-medium px-2.5 py-1 rounded-full bg-gray-100 text-gray-600 border border-gray-200"
                >{s}</span>
              ))}
            </div>

          </div>

          <div>
            <p className="text-[10px] text-gray-400 uppercase tracking-widest font-semibold mb-1.5" >About</p>
            <p className="text-gray-600 text-xs leading-relaxed" >{tutor.bio}</p>
          </div>

          <div>
            <p className="text-[10px] text-gray-400 uppercase tracking-widest font-semibold mb-2" >Certificates</p>
            <span className="flex flex-wrap gap-1.5">
              {tutor.certificate.map((s, i) => (
                <span key={i} className="text-xs font-medium px-3.5 py-1 rounded-full bg-gray-100 text-gray-600 border border-gray-200"
                >{s}</span>
              ))}

            </span>
          </div>

          <div>
            <p className="text-[10px] text-gray-400 uppercase tracking-widest font-semibold mb-2" >Professional Bodies</p>
            <span className="flex flex-wrap gap-1.5">
              {tutor.bodies.map((s, i) => (
                <span key={i} className="text-xs font-medium px-3.5 py-1 rounded-full bg-gray-100 text-gray-600 border border-gray-200"
                >{s}</span>
              ))}

            </span>
          </div>
          <div className="flex flex-col gap-2 pt-1 sm:flex-row">
            <button
              className="flex-1 rounded-xl bg-gray-900 py-2.5 text-sm font-semibold text-white transition-all hover:bg-gray-700 active:scale-95"
              style={{ letterSpacing: '0.03em' }}
            >

              <a href="https://filloptech.com/register" className='text-white no-underline hover:no-underline' >
                Register now!
              </a>
            </button>
            <button
              onClick={onClose}
              className="rounded-xl border border-gray-200 bg-gray-100 px-5 py-2.5 text-sm font-medium text-gray-500 transition-all hover:bg-gray-200 active:scale-95"

            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// ─── Main Component ───────────────────────────────────────────────────────────
export default function TutorCards() {
  const [selected, setSelected] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState([]);
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(false);

  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: 'center',
    containScroll: 'trimSnaps',
    loop: false,
  });

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
    setCanPrev(emblaApi.canScrollPrev());
    setCanNext(emblaApi.canScrollNext());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    setScrollSnaps(emblaApi.scrollSnapList());
    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', onSelect);
    onSelect();
    return () => {
      emblaApi.off('select', onSelect);
      emblaApi.off('reInit', onSelect);
    };
  }, [emblaApi, onSelect]);

  const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi]);
  const scrollTo = useCallback((i) => emblaApi && emblaApi.scrollTo(i), [emblaApi]);

  return (
    <>

      <section className="mx-auto flex w-full flex-col bg-white px-4 py-12 text-center sm:px-8 lg:px-16 lg:py-16" data-aos="fade-up">
        <h2
          className="mx-auto mb-8 max-w-3xl px-2 text-2xl leading-tight text-gray-900 sm:mb-12 sm:text-3xl"
          data-aos="fade-down"
          data-aos-delay="100"
        >
          Meet Our Expert Instructors
        </h2>

        {/* Embla viewport */}
        <div
          className="mx-auto w-full max-w-[1160px] overflow-hidden"
          ref={emblaRef}
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div className="flex touch-pan-y items-stretch" style={{ gap: 0 }}>
            {tutorsData.map((tutor, i) => (
              <div
                key={tutor.id}
                className="min-w-0 flex-none basis-[min(86vw,300px)] px-2.5 sm:basis-[310px] lg:basis-[285px]"
              >
                <TutorCard tutor={tutor} onClick={setSelected} />
              </div>
            ))}
          </div>
        </div>

        {/* Navigation */}
        <div className="mt-6 flex items-center justify-center gap-4" data-aos="fade-up" data-aos-delay="400">
          <button
            onClick={scrollPrev}
            disabled={!canPrev}
            aria-label="Previous"
            style={{
              width: 40, height: 40,
              borderRadius: '50%',
              border: '1px solid #e5e7eb',
              background: 'white',
              cursor: canPrev ? 'pointer' : 'default',
              opacity: canPrev ? 1 : 0.3,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 16, color: '#374151',
              boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
              transition: 'opacity 0.2s',
            }}
          >
            &larr;
          </button>

          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {scrollSnaps.map((_, i) => (
              <DotButton key={i} isSelected={i === selectedIndex} onClick={() => scrollTo(i)} />
            ))}
          </div>

          <button
            onClick={scrollNext}
            disabled={!canNext}
            aria-label="Next"
            style={{
              width: 40, height: 40,
              borderRadius: '50%',
              border: '1px solid #e5e7eb',
              background: 'white',
              cursor: canNext ? 'pointer' : 'default',
              opacity: canNext ? 1 : 0.3,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 16, color: '#374151',
              boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
              transition: 'opacity 0.2s',
            }}
          >
            &rarr;
          </button>
        </div>
      </section>

      <TutorModal tutor={selected} onClose={() => setSelected(null)} />
    </>
  );
}
